export default __webpack_public_path__ + "static/media/hanabi.28f5d3e1.PNG";